import React from 'react';
import Button from '../../../../components/form-control/Button';
import usePolicy from '../../../../hooks/policyHook';
import { Policy } from '../../../../models/policy/Policy';
import { FleetPolicy } from '../../../../models/policy/FleetPolicy';
import { isFleetPolicy, showToast } from '../../../../utils/miscFunctions';
import { approveFleetPolicy } from '../../../../api/requests';
import { useQueryClient } from '@tanstack/react-query';

type Props = {
  policy: Policy | FleetPolicy | undefined;
  onApproved: () => void;
  onCancel: () => void;
}

const PolicyApproval = ({ policy, onApproved, onCancel }: Props) => {
  const { approveSinglePolicy } = usePolicy();
  const policyNumber = policy && "policyNumber" in policy ? policy?.policyNumber :  policy && "ref" in policy ? policy?.ref : '';
  const queryClient = useQueryClient();
  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);

      let response: any;
      if (isFleetPolicy(policy)) {
        response = await approveFleetPolicy(policy?.fleetNumber ?? '');
      } else {
        response = await approveSinglePolicy(String(policyNumber));
      }

      showToast.success(response?.message || "Policy approved successfully");
      queryClient.invalidateQueries({ queryKey: ['fetchCustomer'] });
      queryClient.invalidateQueries({ queryKey: ['getAllCustomerIndividualPolicies'] });
      queryClient.invalidateQueries({ queryKey: ['getAllCustomerFleetPolicies'] });
      queryClient.invalidateQueries({ queryKey: ['getAllCustomerNonMotorPolicies'] });
      
      
      onApproved();
    } catch (error: any) {
      showToast.error(error?.description);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-xl dark:bg-darkBg">
      <div className="p-4">
        <div className="py-3 dark:text-darkBg-mainText">
          <p>
            By approving this policy, you agree that all of the details provided by the
            policy&apos;s owner is accurate as of this day. Do you agree to approve this ?
          </p>
        </div>

        <div className="flex gap-4">
          <Button
            label="Cancel"
            onClick={onCancel}
            disabled={submitting}
            fullWidth
            bgColor='secondary'
          />
          
          <Button
            label="Approve"
            fullWidth
            onClick={handleSubmit}
            loading={submitting}
            disabled={submitting}
            bgColor='primary'
          />
        </div>


        
      </div>
    </div>
  );
};

export default PolicyApproval;
